<template>
  <div>
    <Breadcrumbs 
      :children="[
        {
          text: 'Publicidad',
        }
      ]"/>
    <div class="main-container" style="margin-left:15px;">
      <div class="add-banner-container">
        <div v-if="loading">
          <td class="text-center" colspan="8">
            <Loader />
          </td>
        </div>
        <div v-else class="banner-container-base">
          <div class="add-banner-box">
            <i class="fa fa-camera"></i>
            <br />Arrastra una foto o
            <a
              @click.prevent="triggerPhotoChange"
              href="#"
              class="main-green"
            >Selecciona un archivo</a>
            <input
              accept="image/*"
              type="file"
              id="product-photo"
              class="hidden-file-inp"
              @change="managePhoto($event)"
            />
            <span>300px por 50px formatos: JPG, PNG</span>
          </div>
        </div>
      </div>

      <div v-for="banner in banners" :key="banner.id" class="banner-container-base">
        <a class="deleteme" href="#" @click="deleteBanner(banner)">
          <i class="fa fa-trash fa-2x text-white"></i>
        </a>
        <img :src="banner.image" alt="Banner de publicidad" />
      </div>
    </div>

    <!-- Modal -->
    <div
      class="modal fade"
      id="modal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="modalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="modalLabel">Dimensiones permitidas 300x50</h5>
            <button type="button" class="close" @click="cancelPhotoCrop()">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div style="max-width: 350px;">
              <img id="image" :src="photoPreview" alt="Picture" style="max-width: 100%" />
            </div>
            <div class="form-group mt-3">
              <input type="text" placeholder="Enlace de acción" class="form-control" v-model="banner.link">
            </div>
          </div>
          <div class="modal-footer">
            <div class="row" style="width:100%;margin-left:0;margin-right:0;">
              <div class="col-sm-6 text-left">
                <button
                  type="button"
                  :disabled="loading"
                  class="btn btn-secundary"
                  @click="cancelPhotoCrop()"
                >Cancelar</button>
              </div>
              <div class="col-sm-6 text-right">
                <button
                  type="button"
                  :disabled="loading"
                  class="btn main-bg"
                  @click="savePhotoCrop()"
                >Guardar</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import firebase from "firebase/app";
import PhotoUploader from "../../commons/PhotoUploader";
import Breadcrumbs from "../components/Breadcrumbs";
import {BannerService} from "../../services/BannerService";
import Loader from '../components/Loader'
export default {
  name: "Banners",
  components: { Breadcrumbs, Loader },
  data: function() {
    return {
      db: firebase.firestore(),
      company: "",
      banner: {
        id: "",
        name: "",
        image: null,
        status: 1,
        link: ""
      },
      banners: [],
      photoPreview: "",
      editing: false,
      loading: false,
      cropper: null,
      bannerSize: {
        width: 300,
        height: 50
      },
      bannerService: new BannerService()
    };
  },
  methods: {
    openModal() {
      $("#category-modal").modal({
        keyboard: false,
        backdrop: false
      });
    },
    savePhotoCrop() {
      this.cropper.getCroppedCanvas().toBlob(file => {
        this.banner.image = file;
        this.saveBanner();
      });
    },
    cancelPhotoCrop() {
      if (this.cropper != null) {
        this.cropper.destroy();
        this.cropper = null;
      }
      $("#modal").modal("hide");
    },
    managePhoto(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) {
        return;
      }
      this.loading = true;
      this.banner.image = files[0];
      this.photoPreview = URL.createObjectURL(files[0]);
      setTimeout(() => {
        this.initCropper();
        $("#modal").modal({
          backdrop: false,
          keyboard: false
        });
        this.loading = false;
      }, 1000);
    },
    initCropper() {
      var image = document.querySelector("#image");
      this.cropper = new Cropper(image, {
        viewMode: 3,
        data: {
          width: this.bannerSize.width,
          height: this.bannerSize.height
        }
      });
    },
    triggerPhotoChange() {
      $("#product-photo").trigger("click");
    },
    //TODO
    async saveBanner() {
      if (this.banner.image == null) {
        this.$helpers.toast("La foto es obligatoria", "warning");
        return;
      }
      this.loading = true;
      try {
        const bannerRef = await this.db.collection("Banners");

        const newBanner = await bannerRef.add({
          image: "",
          link: this.banner.link
        });
        const photoUpload = await PhotoUploader.upload(
          "Banners",
          newBanner.id,
          this.banner.image
        );

        await newBanner.update({
          image: photoUpload.url,
          image_ref: photoUpload.fileNameRef
        });

        this.banners.push({
          id: newBanner.id,
          image: photoUpload.url,
          image_ref: photoUpload.fileNameRef
        });

        this.photoPreview = "";
        this.banner = {
          id: "",
          name: "",
          image: null,
          status: 1
        };
        this.loading = false;
        this.cancelPhotoCrop();
        this.$helpers.toast("Datos guardados");
      } catch (e) {
        console.log("ERR >> ", e);
        this.loading = false;
        this.$helpers.toast(e.message, "error");
      }
    },
    async getBanners() {
      this.banners = [];
      this.loading = true;
      const response = await this.bannerService.getBanners();
      if(response.ok){
        this.banners = response.data;
      }else{
        this.$helpers.message('Error', response.message, 'error');
      }
      this.loading = false;
    },
    //TODO
    async deleteBanner(banner) {
      const ok = await this.$helpers.confirm(
        "El banner dejara de aparecer en la app."
      );
      if (!ok) {
        return;
      }
      try {
        await this.db
          .collection("Banners")
          .doc(banner.id)
          .delete();

        await PhotoUploader.deleteFile("Banners", banner.image_ref);

        this.$helpers.toast("Datos eliminados");

        this.banners = this.banners.filter(b => b.id != banner.id);
      } catch (e) {
        console.log(e);
      }
    },
    edit: function(banner) {
      this.editing = true;
      this.banner.id = banner.id;
      this.banner.name = banner.name;
      this.photoPreview = banner.image;
      this.banner.link = banner.link;
      $("#category-modal").modal({
        keyboard: false,
        backdrop: false
      });
    },
  },
  created: async function() {
    this.getBanners();
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
//@import '/node_modules/cropperjs/dist/cropper.css';
.main-container {
  display: flex;
  flex-wrap: wrap;
}
.banner-container-base {
  display: block;
  position: relative;
  margin: 15px 5px;
  width: 300px;
  height: 60px;
  img {
    height: inherit;
    width: inherit;
  }
  .deleteme {
    opacity: 0.7;
    position: absolute;
    right: 0;
    top: 0;
    z-index: 5;
    width: 30px;
    height: 30px;
    background-color: #000;
    text-align: center;
    padding: 2px;
    font-size: 0.7em;
  }
}
.add-banner-container {
  display: flex;
  flex-direction: column;
}
.add-banner-box {
  border-style: dashed;
  border-color: gray;
  padding: 5px 30px;
  text-align: center;
  font-size: 0.7em;
  background-color: #fff;
}

.fs1 {
  font-size: small;
}
.btn1 {
  padding: 3px;
}
* {
  font-weight: 500;
}
.img-container {
  width: 400px;
  height: 400px;
  img {
    display: block;

    /* This rule is very important, please don't ignore this */
    max-width: 100%;
  }
}
.btn-less-padding {
  padding: 2px 6px;
}
</style>
